import { Component, OnInit, Inject } from '@angular/core';
import { RestAPIService } from 'src/app/services/restapi.service';
import { environment } from 'src/environments/environment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigurationTypeEnum } from 'src/app/enums/configurationApiEnum';
import {FormControl, Validators} from '@angular/forms';
import { ConfigurationModel, AddConfigurationMatrixModel } from 'src/app/components/configuration/models/configurationModel';
import { ConfigurationGroupModel } from 'src/app/components/configuration/models/configurationGroupModel';
import { ConfigurationTypeModel } from 'src/app/components/configuration/models/configurationTypeModel';
import { ConfigurationSearchModel } from 'src/app/components/configuration/models/configurationSearchModel';

@Component({
    selector: 'app-copy-configuration',
    templateUrl: './configuraton.copy.component.html'
})
export class CopyConfigurationComponent implements OnInit {
    submitted: boolean = false;
    configurationByTypesList: ConfigurationModel[] = [];
    configurationGroupList: ConfigurationGroupModel[] = [];
    configurationTypeList: ConfigurationTypeModel[] = [];
    configurationModel: ConfigurationModel = new ConfigurationModel();
    productCode: string;
    configurationSearchModel: ConfigurationSearchModel = new ConfigurationSearchModel();
    singleConfigurationTypeCode = ConfigurationTypeEnum.Single;
    matrixConfigurationTypeCode = ConfigurationTypeEnum.Matrix;
    searchConfigurationTypes = ConfigurationTypeEnum.List + "," + ConfigurationTypeEnum.Range;

    groupId = new FormControl('', [Validators.required]);
    configKey = new FormControl('', [Validators.required]);
    configurationTypeCode = new FormControl('', [Validators.required]);
    condition1 = new FormControl('', [Validators.required]);
    
    constructor(public _restAPI: RestAPIService, public dialogRef: MatDialogRef<CopyConfigurationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject(MAT_DIALOG_DATA) public productCodeData: string) {
            this._restAPI.loading  = false;
            this.configurationModel = data.configuration;
            this.configurationModel.addConfigurationMatrixModel = new AddConfigurationMatrixModel();
            this.productCode = data.configuration.productCode;
            this.configurationModel.configKey = this.configurationModel.configKey + "-clone";
        }
    
    async ngOnInit() {
        await this.getConfigurationById();
        await this.getConfigurationGroupList();
        await this.getConfigurationTypeList();
        await this.getConfigurationByTypeList();
    }

    closeDialog(): void {
        this.dialogRef.close(false);
    }

    

    async getConfigurationById() {
        if (this.configurationModel.configurationTypeCode == ConfigurationTypeEnum.Matrix) {
            this._restAPI.loading  = true;
            this._restAPI.get<any>(environment.apiURL + 'api/configuration/' + this.productCode + '/' + this.configurationModel.configurationId).subscribe({
                next: (result) => {
                    this._restAPI.loading  = false;
                    if (result?.configurationMatrix != null){
                        let configurationMatrixDetail = result.configurationMatrix;
                        if (configurationMatrixDetail.condition1 != null) {
                            this.configurationModel.addConfigurationMatrixModel.condition1 = configurationMatrixDetail.condition1.configurationId;
                        }
                        if (configurationMatrixDetail.condition2 != null) {
                            this.configurationModel.addConfigurationMatrixModel.condition2 = configurationMatrixDetail.condition2.configurationId;
                        }
                        if (configurationMatrixDetail.condition3 != null) {
                            this.configurationModel.addConfigurationMatrixModel.condition3 = configurationMatrixDetail.condition3.configurationId;
                        }
                        if (configurationMatrixDetail.condition4 != null) {
                            this.configurationModel.addConfigurationMatrixModel.condition4 = configurationMatrixDetail.condition4.configurationId;
                        }
                        if (configurationMatrixDetail.condition5 != null) {
                            this.configurationModel.addConfigurationMatrixModel.condition5 = configurationMatrixDetail.condition5.configurationId;
                        }
                    }
                },
                error: (error) => {this._restAPI.loading  = false;console.error(error)}
            });
        }
    }

    async getConfigurationByTypeList() {
        this._restAPI.loading  = true;
        this._restAPI.get<ConfigurationModel[]>(environment.apiURL + 'api/configuration/' + this.productCode + '/configurationType/' + this.searchConfigurationTypes).subscribe({
            next: (results) => {
                this._restAPI.loading  = false;
                this.configurationByTypesList = results;
            },
            error: (error) => {this._restAPI.loading  = false;console.error(error)}
        });
    }

    async getConfigurationGroupList() {
        this._restAPI.loading  = true;
        this._restAPI.get<ConfigurationGroupModel[]>(environment.apiURL + 'api/configuration/' + this.productCode + '/group').subscribe({
            next: (results) => {
                this._restAPI.loading  = false;
                this.configurationGroupList = results;
            },
            error: (error) => {this._restAPI.loading  = false;console.error(error)}
        });
    }
    
    async getConfigurationTypeList() {
        this._restAPI.loading  = true;
        this._restAPI.get<ConfigurationTypeModel[]>(environment.apiURL + 'api/configuration/' + this.productCode + '/type').subscribe({
            next: (results) => {
                this._restAPI.loading  = false;
                this.configurationTypeList = results;
            },
            error: (error) => {this._restAPI.loading  = false;console.error(error)}
        });
    }

    async copyConfiguration() {
        this.submitted = true;
        if(!this.groupId.invalid && !this.configKey.invalid && !this.configurationTypeCode.invalid &&
            (this.configurationModel.configurationTypeCode != this.matrixConfigurationTypeCode || (!this.condition1.invalid) )){
            
            let postData = {};
            if (this.configurationModel.configurationTypeCode != this.matrixConfigurationTypeCode) {
                postData = {
                    name: this.configurationModel.name,
                    description: this.configurationModel.description,
                    groupId: this.configurationModel.groupId,
                    configKey: this.configurationModel.configKey,
                    configurationTypeCode: this.configurationModel.configurationTypeCode,
                    value: this.configurationModel.value
                };
            }
            else {
                postData = {
                    name: this.configurationModel.name,
                    description: this.configurationModel.description,
                    groupId: this.configurationModel.groupId,
                    configKey: this.configurationModel.configKey,
                    configurationTypeCode: this.configurationModel.configurationTypeCode,
                    value: this.configurationModel.value,
                    addConfigurationMatrixModel: this.configurationModel.addConfigurationMatrixModel
                };
            }
            this._restAPI.loading  = true;
            this._restAPI.put<string>(environment.apiURL + 'api/configuration/' + this.productCode + '/copyconfiguration/' + this.configurationModel.configurationId, postData).subscribe({
                next: (results) => {
                    this._restAPI.loading  = false;
                    this.submitted = false;
                    this.dialogRef.close(true);
                },
                error: (error) => {this._restAPI.loading  = false;console.error(error)}
            });
        }
    }

    onTypeChange() {
        if (this.configurationModel.configurationTypeCode != this.matrixConfigurationTypeCode) {
            this.configurationModel.addConfigurationMatrixModel.condition1 = null;
            this.onConditionChange();
        }
    }

    onConditionChange() {
        if (this.configurationModel.addConfigurationMatrixModel.condition1 == null || this.configurationModel.addConfigurationMatrixModel.condition1.length <= 0) {
            this.configurationModel.addConfigurationMatrixModel.condition2 = null;      
        }

        if (this.configurationModel.addConfigurationMatrixModel.condition2 == null || this.configurationModel.addConfigurationMatrixModel.condition2.length <= 0) {
            this.configurationModel.addConfigurationMatrixModel.condition3 = null;      
        }

        if (this.configurationModel.addConfigurationMatrixModel.condition3 == null || this.configurationModel.addConfigurationMatrixModel.condition3.length <= 0) {
            this.configurationModel.addConfigurationMatrixModel.condition4 = null;      
        }

        if (this.configurationModel.addConfigurationMatrixModel.condition4 == null || this.configurationModel.addConfigurationMatrixModel.condition4.length <= 0) {
            this.configurationModel.addConfigurationMatrixModel.condition5 = null;      
        }
    }
}
